import React from "react";
import { useEffect, useState } from "react";
import auth from "../services/auth";
import styled from "styled-components";
import { NavLink, useHistory, useLocation } from "react-router-dom";

function Navbar({ handleUser }) {
  const [user, setUser] = useState();
  const [logoOnDark, setLogoOnDark] = useState(false);
  const location = useLocation();
  const hideLogo = user && location.pathname === "/admin";

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    function checkOverlap() {
      const darkSection = document.querySelector('[data-theme="dark"]');
      if (!darkSection) return;
      const rect = darkSection.getBoundingClientRect();
      // Logo is fixed at top:10, height:120 → occupies y 10–130
      const logoTop = 10;
      const logoBottom = 130;
      const overlaps = rect.top < logoBottom && rect.bottom > logoTop;
      setLogoOnDark(overlaps);
    }
    window.addEventListener("scroll", checkOverlap, { passive: true });
    checkOverlap();
    return () => window.removeEventListener("scroll", checkOverlap);
  }, []);

  async function getUser() {
    const user = await auth.getCurrentUser();
    if (user) setUser(user);
    return () => handleUser(user);
  }

  return (
    <div>
      <Container className="Navbar">
        {!hideLogo && (
          <Link to="/">
            <Logo src={"logo11.png"} $inverted={logoOnDark}></Logo>
          </Link>
        )}
        <Facebook>
          {!user && (
            <img
              onClick={() =>
                window.open(
                  "https://www.facebook.com/profile.php?id=100063695312543",
                  "_blank"
                )
              }
              src="facebook.png"
            ></img>
          )}
        </Facebook>
        <Instagram>
          {!user && (
            <img
              onClick={() =>
                window.open("https://www.instagram.com/ellllibelli/", "_blank")
              }
              className="instagram"
              src="instagram.png"
            ></img>
          )}
        </Instagram>
        {user && (
          <AdminLink to="/admin">
            ⚙ Admin
          </AdminLink>
        )}
      </Container>
    </div>
  );
}

export default Navbar;

const Container = styled.div`
  height: 180px;
  width: 100%;
  display: flex;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  background-color: transparent;
  h1 {
    top: 60px;
    right: 06px;
    font-size: 12px;
    color: black;
    position: fixed;
    @media screen and (max-width: 1000px) {
      font-size: 20px;
      top: 80px;
    }
  }
`;

const Link = styled(NavLink)`
  :hover {
  }
`;
const Logo = styled.img`
  height: 120px;
  width: 240px;
  display: flex;
  justify-self: left;
  margin-top: 10px;
  opacity: 1;
  position: fixed;
  z-index: 999;
  top: 10px;
  left: 10px;
  filter: ${({ $inverted }) => $inverted ? "invert(1) hue-rotate(180deg)" : "none"};
  transition: filter 0.3s ease;

  @media screen and (max-width: 1000px) {
    height: 250px;
    width: 420px;
  }
`;

const Facebook = styled.div`
  img {
    top: 3px;
    right: 80px;
    height: 50px;
    margin-top: 5px;
    position: fixed;
    border-radius: 12px;
    z-index: 999;
    cursor: pointer;
    @media screen and (max-width: 1000px) {
      height: 100px;
      right: 150px;
    }
  }
`;
const AdminLink = styled(NavLink)`
  position: fixed;
  top: 14px;
  right: 20px;
  z-index: 999;
  background: rgba(160, 101, 53, 0.9);
  color: #fff;
  text-decoration: none;
  font-family: helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 8px;
  letter-spacing: 0.04em;
  transition: background 0.2s;
  &:hover { background: rgba(160, 101, 53, 1); }

  @media screen and (max-width: 1000px) {
    font-size: 22px;
    padding: 14px 28px;
    top: 18px;
    right: 20px;
  }
`;

const Instagram = styled.div`
  img {
    top: 0px;
    right: 20px;
    height: 55px;
    margin-top: 5px;
    position: fixed;
    border-radius: 2px;
    z-index: 999;
    cursor: pointer;
    @media screen and (max-width: 1000px) {
      height: 122px;
      top: -5px;
    }
  }
`;
